export default __webpack_public_path__ + "static/uiux-307455ff55344ccfaa5e614d90532a09.png";